import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import ToastHost from '../components/ToastHost';
import AuthGate from './AuthGate';
import ErrorBoundary from '../components/ErrorBoundary';
import GlobalErrorBanner from '../components/GlobalErrorBanner';

export default function AppLayout() {
  const loc = useLocation();
  return (
    <AuthGate>
      <div className="app-shell">
        <Sidebar />
        <Topbar />
        <main className="main">
          {/* 2026-05-28: per-route error boundary. A render crash in one page
              now shows an inline error card with the stack instead of blanking
              the whole app to white. Keyed on pathname so navigating to a
              different page resets the boundary automatically. */}
          <ErrorBoundary
            key={loc.pathname}
            fallback={(err, reset) => (
              <div style={{ padding: 24 }}>
                <div style={{ background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca', padding: 16, borderRadius: 8, maxWidth: 820, margin: '20px auto' }}>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>This page hit an error.</div>
                  <div style={{ fontSize: 12, marginBottom: 8, color: '#7f1d1d' }}>The rest of the app still works — use the sidebar to navigate away, or retry.</div>
                  <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11, margin: 0, maxHeight: 240, overflow: 'auto' }}>{String(err?.stack ?? err?.message ?? err)}</pre>
                  <button onClick={reset} className="btn" style={{ marginTop: 10 }}>Try again</button>
                </div>
              </div>
            )}
          >
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <ToastHost />
      <GlobalErrorBanner />
    </AuthGate>
  );
}
